import React, { useCallback, useEffect, useState } from 'react';

import { NoVariables } from './components/NoVariables';
import { VariablesPopout } from './components/VariablesPopout';
import { useUserTraits } from './useUserTraits';

interface VariableFormData {
  id?: string; // exists when it is a variable
  name: string;
  fallback: string;
}

interface VariableEditorProps {
  onClose: () => void;
  onVariable: (data: VariableFormData) => void;
  initialValue: VariableFormData;
}

export const VariableEditor = ({ onClose, onVariable, initialValue }: VariableEditorProps) => {
  const [loading, setLoading] = useState(true);
  const [name, setName] = useState('');
  const [fallback, setFallback] = useState(initialValue.fallback);

  const traits = useUserTraits();

  const isSubmitEnabled = name !== '';

  const onSubmit = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();

      if (!isSubmitEnabled) {
        return;
      }

      onVariable({ name, fallback });
    },
    [name, fallback],
  );

  useEffect(() => {
    if (traits?.data && name.length === 0 && initialValue.name) {
      const trait = traits.data.find((item: any) => item.name === initialValue.name);

      // if initial name matches one of traits, set the name
      // or if it's a custom variable that has an id, set the name
      if (trait || (initialValue.id && initialValue.name)) {
        setName(initialValue.name);
      }
      setLoading(false);
    }
  }, [traits?.data]);

  if (loading) {
    return <></>;
  }

  const hasVariables = traits?.data && traits.data.length > 0;

  const options = (traits?.data || []).map((trait) => ({
    value: trait.name,
    label: trait.name,
  }));

  const variableFormProps = {
    name,
    setName,
    fallback,
    setFallback,
    options,
    onClose,
    onSubmit,
    isSubmitEnabled,
  };

  if (!hasVariables) {
    return <NoVariables onClose={onClose} />;
  }
  return <VariablesPopout variableFormProps={variableFormProps} />;
};
